import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "col-md-6 mx-auto" }
const _hoisted_2 = { class: "dl-horizontal" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("dt", null, "ID", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("dt", null, "Name", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("dt", null, "Code", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("dt", null, "Feature", -1)
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("dt", null, "Data", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("dt", null, "Quantity", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("dt", null, "Receive Limit", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("dt", null, "Revceive Counter", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("dt", null, "Status", -1)
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("dt", null, "Start Time", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("dt", null, "End Time", -1)
const _hoisted_16 = { class: "card-footer bg-white border border-light" }
const _hoisted_17 = { class: "col text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_card = _resolveComponent("app-card")!

  return (_openBlock(), _createBlock(_component_app_card, {
    class: "col-lg-8 mx-auto",
    label: "Promotion Code"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("dl", _hoisted_2, [
          _createElementVNode("tr", null, [
            _hoisted_3,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.id), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_4,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.name), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_5,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.code), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_6,
            _createElementVNode("dd", {
              innerHTML: _ctx.renderOption(_ctx.Options.features, _ctx.model.feature)
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_8,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.data), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_9,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.quantity), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_10,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.receiveLimit), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_11,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.receiveCounter), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_12,
            _createElementVNode("dd", {
              innerHTML: _ctx.renderOption(_ctx.Options.statusList, _ctx.model.status)
            }, null, 8, _hoisted_13)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_14,
            _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.model.startTime.getTime())), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_15,
            _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.model.endTime.getTime())), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          (_ctx.model.canEnable)
            ? (_openBlock(), _createBlock(_component_app_button, {
                key: 0,
                name: "Enable",
                icon: "fa-play",
                theme: "success",
                onClick: _ctx.actions.enable
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.model.canDisable)
            ? (_openBlock(), _createBlock(_component_app_button, {
                key: 1,
                name: "Disable",
                icon: "fa-stop",
                theme: "warning",
                onClick: _ctx.actions.disable
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.model.canDelete)
            ? (_openBlock(), _createBlock(_component_app_button, {
                key: 2,
                name: "Delete",
                icon: "fa-trash-alt",
                theme: "danger",
                onClick: _ctx.actions.remove
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}